export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  for (const keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {}
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    }
  }
  return targetObj
}

/**
 * 生成时间日，时，分，秒，返回一个数组
 * @param {*} st startTime 一个Date对象，或者日期格式的字符串
 * @param {*} et endTime Date对象，或者日期格式的字符串
 */
export function getDuration (startTime, endTime) {
  // let startTime = new Date(st.replace(/-/g, '/'))
  // let endTime = new Date(et.replace(/-/g, '/'));

  let currentStartTime = '';
  let currentEndTime = '';

  if (typeof startTime === 'string') {
    currentStartTime = new Date(startTime.replace(/-/g, '/')).getTime();
  } else {
    currentStartTime = startTime.getTime()
  }

  if (typeof endTime === 'string') {
    currentEndTime = new Date(endTime.replace(/-/g, '/')).getTime();
  } else {
    currentEndTime = endTime.getTime()
  }

  let time = currentEndTime - currentStartTime;

  if (time < 0) {
    throw "结束时间不能比开始时间小";
  } else {
    let calcSecond = time / 1000;
    let day = Math.floor(calcSecond / 60 / 60 / 24) + '';
    let hour = Math.floor(calcSecond / 60 / 60 % 24) + '';
    let minute = Math.floor(calcSecond / 60 % 60) + '';
    let second = Math.floor(calcSecond % 60) + '';

    day = (0 + day).slice(-2);
    hour = (0 + hour).slice(-2);
    minute = (0 + minute).slice(-2);
    second = (0 + second).slice(-2);

    return [day, hour, minute, second]
  }
}


// WEBPACK FOOTER //
// ./src/utils/util.js